import React, { useState, useRef, useEffect } from 'react';
import StickyHeader from "../../../../components/ModuleCommon/StickyHeader/StickyHeader";
import Button from '../../../../components/ACS-Dashboard/ACS-Blocks/Button';
import FormMessages from './FormMessage';
import CreateShipmentTab from '../../Shipment/TabContent/CreateShipmentTab';

const NewMessage = () => {
    const [infoData, setInfoData] = useState({
        "Order date": { type: "date", value: "12/22/2024" },
        "Order number": { type: "text", value: "#004363" },
        "Delivery date request": { type: "date", value: "01/14/2025" },
        "Payment type": { 
            type: "dropdown", 
            value: "",
            options: ["Credit Card", "Bank Transfer", "COD"] 
        }
    });

    const headerRef = useRef(null);
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const updateHeaderHeight = () => {
            if (headerRef.current) {
                setHeaderHeight(headerRef.current.offsetHeight);
            }
        };

        updateHeaderHeight();
        window.addEventListener('resize', updateHeaderHeight);
        return () => window.removeEventListener('resize', updateHeaderHeight);
    }, []);

    const handleInfoChange = (fieldName, newValue) => {
        setInfoData(prev => ({
            ...prev,
            [fieldName]: { ...prev[fieldName], value: newValue }
        }));
    };

    const templates = ["Template 1", "Template 2", "Template 3"];
    const handleSendPurchaseOrder = () => console.log("Send Purchase Order");
    const handleSaveDraft = () => console.log("Save as Draft");
    const buttons = [
        { label: "Send purchase order", type: "primary", onClick: handleSendPurchaseOrder },
        { label: "Save as draft", type: "secondary", onClick: handleSaveDraft },
    ];
    const [isTemplateSaved, setIsTemplateSaved] = useState(false);

    return (
        <div className="w-full h-full flex flex-col gap-fluid-2">
            {/* Fluid Sticky Header */}
            <div ref={headerRef} className="sticky top-0 z-50 bg-white shadow-md w-full">
                <StickyHeader
                    infoData={infoData}
                    onInfoChange={handleInfoChange}
                    templates={templates}
                    onSelectTemplate={console.log}
                    buttons={buttons}
                    saveTemplateConfig={{
                        checked: isTemplateSaved,
                        onChange: () => setIsTemplateSaved(prev => !prev),
                    }}
                />
            </div>

            {/* Fluid Scrollable Content */}
            <div 
                className="flex-1 overflow-y-auto bg-gray-50 w-full p-fluid-2 rounded-lg shadow-inner"
                style={{ 
                    height: `calc(100vh - ${headerHeight}px - ${headerHeight > 0 ? '1rem' : '0px'})`,
                    scrollPaddingTop: '1rem'
                }}
            >
                <FormMessages className="flex flex-col gap-fluid-3" />
            </div>
        </div>
    );
};

export default NewMessage;